var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEventBusyFilled = function SvgEventBusyFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M8.75 2a.75.75 0 0 0-1.5 0v1.25H5A2.75 2.75 0 0 0 2.25 6v13A2.75 2.75 0 0 0 5 21.75h9.546a5.258 5.258 0 0 0 3.728.65 5.25 5.25 0 0 0 3.476-7.854V6A2.75 2.75 0 0 0 19 3.25h-2.25V2a.75.75 0 0 0-1.5 0v1.25h-6.5V2Zm-5 7.75h16.5v3.192a5.25 5.25 0 0 0-7.308 7.308H5c-.69 0-1.25-.56-1.25-1.25V9.75Zm12.28 5.22a.75.75 0 1 0-1.06 1.06l1.22 1.22-1.22 1.22a.75.75 0 1 0 1.06 1.06l1.22-1.22 1.22 1.22a.75.75 0 1 0 1.06-1.06l-1.22-1.22 1.22-1.22a.75.75 0 1 0-1.06-1.06l-1.22 1.22-1.22-1.22Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEventBusyFilled);
export default ForwardRef;